import { render, staticRenderFns } from "./MasterDataLanding.vue?vue&type=template&id=2df7465b&"
import script from "./MasterDataLanding.vue?vue&type=script&lang=js&"
export * from "./MasterDataLanding.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports